const example = () => {
  console.info('This is an example to show the use of import/export syntax.')
};

export default example;
